import type {
  AccessorialScheduleDetail,
  AccessorialScheduleListItem,
  SelectedAccessorialCharge,
} from "../../hooks/react-query/backOffice/useAccessorialSchedules";

// Mock data for list view (matches AccessorialScheduleListItem type)
export const mockAccessorialSchedulesListItems: AccessorialScheduleListItem[] =
  [
    {
      id: 1,
      name: "Standard Schedule",
      description: "Standard accessorial charges schedule",
      numberOfAccessorialCharges: 3,
      status: "Active",
    },
    {
      id: 2,
      name: "Premium Schedule",
      description: "Premium tier accessorial charges",
      numberOfAccessorialCharges: 5,
      status: "Active",
    },
    {
      id: 3,
      name: "Express Schedule",
      description: "Express delivery accessorial charges",
      numberOfAccessorialCharges: 2,
      status: "Draft",
    },
    {
      id: 4,
      name: "Economy Schedule",
      description: "Economy tier accessorial charges",
      numberOfAccessorialCharges: 4,
      status: "Active",
    },
    {
      id: 5,
      name: "Special Handling Schedule",
      description: "Special handling requirements charges",
      numberOfAccessorialCharges: 6,
      status: "Inactive",
    },
    {
      id: 6,
      name: "Holiday Schedule",
      description: "Holiday period accessorial charges",
      numberOfAccessorialCharges: 3,
      status: "Draft",
    },
    {
      id: 174,
      name: "Test Schedule 174",
      description: "Test schedule for development",
      numberOfAccessorialCharges: 2,
      status: "Active",
    },
  ];

// Mock data for selected accessorial charges (shared across schedules)
const mockSelectedAccessorialChargesForSchedule1: SelectedAccessorialCharge[] =
  [
    {
      id: 1,
      code: "BlindFee",
      description: "Blind Shipment Fee",
      rateConfiguration: "Flat Rate",
      rateMinMax: "$1,699",
      appliesTo: "Pickup",
      autoAssign: "No",
      status: "Active",
    },
    {
      id: 3,
      code: "BlindFee3",
      description: "Blind Shipment Fee",
      rateConfiguration: "Rate per Unit",
      rateMinMax: "$1,699 ($3,699, $1,699)",
      appliesTo: "Delivery",
      autoAssign: "Yes",
      status: "Active",
    },
  ];

const mockSelectedAccessorialChargesForSchedule197: SelectedAccessorialCharge[] =
  [
    {
      id: 80,
      code: "ArbChg",
      description: "",
      rateConfiguration: "RC",
      rateMinMax: "",
      appliesTo: "Both",
      autoAssign: "No",
      status: "Active",
    },
  ];

// Mock data for detail view (matches AccessorialScheduleDetail type)
export const mockAccessorialSchedules: AccessorialScheduleDetail[] = [
  {
    id: 1,
    name: "Standard Schedule",
    description: "Standard accessorial charges schedule",
    status: "Active",
    createdBy: "John Doe",
    createdOn: "01/15/2025",
    isGlobal: true,
    hasAccounts: false,
    selectedAccessorialCharges: mockSelectedAccessorialChargesForSchedule1,
  },
  {
    id: 2,
    name: "Premium Schedule",
    description: "Premium tier accessorial charges",
    status: "Active",
    createdBy: "Jane Smith",
    createdOn: "01/10/2025",
    isGlobal: false,
    hasAccounts: true,
    selectedAccessorialCharges: mockSelectedAccessorialChargesForSchedule1,
  },
  {
    id: 3,
    name: "Express Schedule",
    description: "Express delivery accessorial charges",
    status: "Draft",
    createdBy: "Carlos Mendez",
    createdOn: "01/20/2025",
    isGlobal: false,
    hasAccounts: false,
    selectedAccessorialCharges: [],
  },
  {
    id: 4,
    name: "Economy Schedule",
    description: "Economy tier accessorial charges",
    status: "Active",
    createdBy: "Sarah Johnson",
    createdOn: "01/05/2025",
    isGlobal: false,
    hasAccounts: true,
    selectedAccessorialCharges: mockSelectedAccessorialChargesForSchedule1,
  },
  {
    id: 5,
    name: "Special Handling Schedule",
    description: "Special handling requirements charges",
    status: "Inactive",
    createdBy: "Michael Brown",
    createdOn: "12/28/2024",
    isGlobal: false,
    hasAccounts: true,
    selectedAccessorialCharges: [],
  },
  {
    id: 6,
    name: "Holiday Schedule",
    description: "Holiday period accessorial charges",
    status: "Draft",
    createdBy: "Emily Davis",
    createdOn: "01/18/2025",
    isGlobal: false,
    hasAccounts: false,
    selectedAccessorialCharges: [],
  },
  {
    id: 174,
    name: "Test Schedule 174",
    description: "Test schedule for development",
    status: "Active",
    createdBy: "Test User",
    createdOn: "01/23/2025",
    isGlobal: false,
    hasAccounts: true,
    selectedAccessorialCharges: mockSelectedAccessorialChargesForSchedule1,
  },
  {
    id: 197,
    name: "efrgth",
    description: "efrgthyj",
    status: "Active",
    createdBy: "Jaya Mudedla",
    createdOn: "04/27/2026",
    isGlobal: false,
    hasAccounts: true,
    selectedAccessorialCharges: mockSelectedAccessorialChargesForSchedule197,
  },
];
